import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { config } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class HttpRequestService {

  constructor(private http: HttpClient, private configService: ConfigService,  public translate: TranslateService) { }


  private createRequestHeader() {
    // set headers here e.g.
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': this.translate.currentLang
    });

    return headers;
  }

  private createFileHeader() {
    // set headers here e.g.
    const headers = new HttpHeaders({
      'Content-Type': 'multipart/form-data'
    });
    return headers;
  }

  private createAuthRequestHeader(toekn) {
    // set headers here e.g.
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${toekn}`,
      'Content-Type': 'application/json',
    });

    return headers;
  }

  GetRequest(path: string) {

    const url = this.configService.getApiURI() + '/' + path;
    // console.log(url);
    //  let headers= new Headers();
    // headers.append('Content-Type', 'application/json');
    const headers = this.createRequestHeader();

    // let options = new RequestOptions({ headers: headers });
    return this.http.get(url);
  }
  deleteRequest(path: string) {

    const url = this.configService.getApiURI() + '/' + path;
    const headers = this.createRequestHeader();
    return this.http.delete(url);
  }
  GetAuthRequest(path: string) {

    const url = this.configService.getApiURI() + '/' + path;
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const authToken = localStorage.getItem(this.configService.getToken());
    if (authToken) {
      const token = JSON.parse(authToken);
      const toeknStr = token.auth_token;
      const headers = this.createAuthRequestHeader(toeknStr);

      // headers.append('Authorization', `Bearer ${toeknStr}`);
      // let options = new RequestOptions({ headers: headers });
      // tslint:disable-next-line: object-literal-shorthand
      return this.http.get(url, { headers: headers });
    }
  }

  postRequest(path: string, body: any) {

    const url = this.configService.getApiURI() + '/' + path;
    const headers = this.createRequestHeader();
    headers.append('Content-Type', 'application/json');
    // let options = new RequestOptions({ headers: headers });

    // tslint:disable-next-line: object-literal-shorthand
    //  console.log(JSON.stringify(body));
    return this.http.post(url, body, { headers });


  }
  postFile(path: string, body: any) {

    const url = this.configService.getApiURI() + '/' + path;
    const headers = this.createFileHeader();
    // headers.append('Content-Type', 'application/json');
    //  let options = new RequestOptions({ headers: headers });

    // tslint:disable-next-line: object-literal-shorthand

    return this.http.post(url, body);
  }
  async postRequestasync(path: string, body: any) {

    const url = this.configService.getApiURI() + '/' + path;
    const headers = this.createRequestHeader();
    // headers.append('Content-Type', 'application/json');
    //  let options = new RequestOptions({ headers: headers });

    // tslint:disable-next-line: object-literal-shorthand
    const data = await this.http.post(url, JSON.stringify(body), { headers: headers }).toPromise();
    return data;
  }
  postAuthRequest(path: string, body: any) {

    const url = this.configService.getApiURI() + '/' + path;
    /// let headers= new Headers();
    //  headers.append('Content-Type', 'application/json');
    const authToken = localStorage.getItem(this.configService.getToken());
    if (authToken) {
      const token = JSON.parse(authToken);
      const toeknStr = token.auth_token;
      const headers = this.createAuthRequestHeader(toeknStr);
      // headers.append('Authorization', `Bearer ${toeknStr}`);
      // let options = new RequestOptions({ headers: headers });
      // tslint:disable-next-line: object-literal-shorthand
      return this.http.post(url, JSON.stringify(body), { headers: headers });
    }
  }

  jsonp(url) {
       return this.http.jsonp(url, 'callback');
  }
}
